document.addEventListener('DOMContentLoaded', function () {

    function toggleLoyaltyLion() {
        const chattyPopup = document.getElementById('Avada_Faq_Popup-Container');
        const loyaltyLion = document.getElementById('loyaltylion-beacon-frame');

        if (!loyaltyLion) return;

        loyaltyLion.style.display = chattyPopup ? 'none' : '';
    }

    // Initial state
    toggleLoyaltyLion();

    // Observe DOM changes
    const observer = new MutationObserver(toggleLoyaltyLion);

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
});